import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fb37a3eb: FaireBrandEntity = {
  token: "b_fb37a3eb",
  type: "brand",
  name: "Good Medicine Beauty Lab",
  avatarUrl:
    "https://cdn.faire.com/fastly/f4da818a8dc6378bce01cacee5a59d1816089d0996513a20d421f4d5e615aa7c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/72c48b5b07d306817826614ec32d61cc3d5344462f04cc27affef60c611e978e/1555384904.jpg",
  logoUrl:
    "https://cdn.faire.com/fastly/f4da818a8dc6378bce01cacee5a59d1816089d0996513a20d421f4d5e615aa7c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/72c48b5b07d306817826614ec32d61cc3d5344462f04cc27affef60c611e978e/1555384904.jpg",
  location: "St. George, UT, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 184,
  isTopShop: true,
  isInsider: true,
  description:
    "Good Medicine is a gift from the desert. The Beauty Lab is a collaboration of 2 women who have come together, inspired by the place we love most – the Southwest desert. We complement each other so well; the result is our wild desert creations. The desert is such a powerful and beautiful place. The plants that grow and thrive in this sometimes extreme climate remind us that we, as women, are free to thrive anywhere and everywhere. That's the beauty and the magic in our line of handcrafted, desert-born products. They are derived from powerful botanicals that thrive in a wild desert landscape and we are lucky enough to have the privilege to bottle up the desert and deliver it to women all over the world. We love combining these amazing plants and essences to create wonderfully nourishing products for your skin!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:52.742Z",
    importedBy: "entity-db-cli",
  },
};
